import { useState } from 'react';
import { getBrowserType } from 'helpers';
import StudentInvitedAboutUs from './StudentInvitedAboutUs';
import StudentInvitedImportantCities from './StudentInvitedImportantCities';
import StudentInvitedInstallExtension from './StudentInvitedInstallExtension';
import StudentInvitedReadingAnalysisPin from './StudentInvitedReadingAnalysisPin';

const EXTENSION_URLS = {
  chrome: process.env.REACT_APP_CHROME_EXTENSION_URL,
  firefox: process.env.REACT_APP_FIREFOX_EXTENSION_URL,
  safari: process.env.REACT_APP_SAFARI_EXTENSION_URL,
  edge: process.env.REACT_APP_EDGE_EXTENSION_URL,
};

function StudentInvited({ onComplete, ...props }) {
  const [step, setStep] = useState(0);

  function openExtensionUrl() {
    const b = getBrowserType();
    const url =
      (b.isChrome && EXTENSION_URLS.chrome) ||
      (b.isFirefox && EXTENSION_URLS.firefox) ||
      (b.isSafari && EXTENSION_URLS.safari) ||
      (b.isEdge && EXTENSION_URLS.edge);
    if (url) window.open(url, '_blank');
  }

  if (step === 0) {
    return (
      <StudentInvitedAboutUs
        {...props}
        onContinue={async () => {
          setStep(1);
        }}
      />
    );
  }

  if (step === 1) {
    return (
      <StudentInvitedImportantCities
        {...props}
        onContinue={async () => {
          setStep(2);
        }}
      />
    );
  }

  if (step === 2) {
    return (
      <StudentInvitedInstallExtension
        onInstall={async () => {
          openExtensionUrl();
          setStep(3);
        }}
        onSkip={async () => {
          await onComplete();
        }}
      />
    );
  }

  if (step === 3) {
    return (
      <StudentInvitedReadingAnalysisPin
        onContinue={async () => {
          await onComplete();
        }}
      />
    );
  }

  return null;
}

export default StudentInvited;
